import React from 'react';
import { MapPin, Mail, Phone, Github, Linkedin, GraduationCap, Target, Zap, User } from 'lucide-react';
import { Card } from './ui/card';
import FootballTimeline from './FootballTimeline';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="about-container">
        
        {/* --- LE NOUVEL EN-TÊTE MODERNE (Comme Skills et Projets) --- */}
        <div className="modern-section-header">
          <div className="modern-badge">
            <User size={16} />
            <span>À Propos</span>
          </div>
          <h2 className="modern-title">
            Qui <span className="modern-highlight">Suis-Je ?</span>
          </h2>
          <p className="modern-subtitle">
            En savoir plus sur mon parcours et ma passion pour la technologie.
          </p>
        </div>

        {/* --- TON ANCIEN FORMAT À DEUX COLONNES --- */}
        <div className="about-content">
          <Card className="about-main-card">
            <div className="card-inner">
              <div className="profile-section">
                
                {/* TA PHOTO PARFAITEMENT CENTRÉE */}
                <div className="avatar-badge-luxury">
                  <div className="avatar-photo-container">
                    <img src="/images/PhotoMoi.png" alt="Omar Aldroubi" className="profile-photo" />
                  </div>
                </div>

                <h3 className="profile-name">Omar Aldroubi</h3>
                <p className="profile-title">Étudiant en Informatique</p>
                <div className="profile-location">
                  <MapPin size={16} />
                  <span>Caen, Normandie</span>
                </div>
              </div>

              <div className="about-description">
                <p>
                  Étudiant en <strong>Licence informatique</strong> à l'Université de Caen, je suis passionné par 
                  la <strong>création de projets concrets</strong>, le <strong>développement logiciel</strong>, <strong>la cybersécurité</strong> et <strong>l'innovation technologique</strong>.
                </p>
                <p>
                  J'ai une grande aisance dans l'acquisition de nouvelles compétences et une solide capacité 
                  d'adaptation. <strong>Dynamique</strong> et <strong>motivé</strong>, mon objectif est de devenir 
                  <strong> Ingénieur spécialisé en Informatique</strong>.
                </p>
              </div>
            </div>
          </Card>

          <div className="about-sidebar">
            <Card className="highlights-card">
              <h4 className="card-title">
                <Target size={20} />
                Points Forts
              </h4>
              <div className="highlights-list">
                <div className="highlight-item">
                  <GraduationCap className="highlight-icon" />
                  <div>
                    <div className="highlight-title">Apprentissage Rapide</div>
                    <div className="highlight-desc">Grande aisance d'acquisition</div>
                  </div>
                </div>
                <div className="highlight-item">
                  <Zap className="highlight-icon" />
                  <div>
                    <div className="highlight-title">Adaptabilité</div>
                    <div className="highlight-desc">Capacité d'adaptation solide</div>
                  </div>
                </div>
                <div className="highlight-item">
                  <Target className="highlight-icon" />
                  <div>
                    <div className="highlight-title">Motivation</div>
                    <div className="highlight-desc">Dynamique et déterminé</div>
                  </div>
                </div>
              </div>
            </Card>

            <Card className="contact-card">
              <h4 className="card-title">
                <Mail size={20} />
                Contact
              </h4>
              <div className="contact-list">
                <a href="mailto:contact@omaraldroubi.fr" className="contact-link">
                  <Mail size={16} />
                  <span>contact@omaraldroubi.fr</span>
                </a>
                <a href="tel:0618798889" className="contact-link">
                  <Phone size={16} />
                  <span>06 18 70 98 89</span>
                </a>
                <a 
                  href="https://github.com/Omar-Aldroubi" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  <Github size={16} />
                  <span>Omar-Aldroubi</span>
                </a>
                <a 
                  href="https://www.linkedin.com/in/omar-aldroubi-b43173291/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  <Linkedin size={16} />
                  <span>Omar Aldroubi</span>
                </a>
              </div>
            </Card>
          </div>
        </div>

        {/* Football Timeline */}
        <FootballTimeline />
      </div>
    </section>
  );
};

export default About;